module.exports = __webpack_public_path__ + "static/img/daiyunying_jiaojie.da9079b9.png";